// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"15c1ed62","732":"2c03100a","977":"56090d08"}[chunkId] + ".chunk.js";
};